import React from 'react';
import styles from './TechStack.module.css';
import {
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaReact,
  FaNodeJs,
  FaGitAlt,
  FaGithub,
  FaPhp,
} from 'react-icons/fa';
import { SiMysql, SiMongodb } from 'react-icons/si';

export default function TechStack() {
  return (
    <section className={styles.stack} id="stack">
      <h2>Tech Stack</h2>
      <p>Tools & technologies I work with:</p>
      <div className={styles.icons}>
        <FaHtml5 className={styles.icon} title="HTML5" />
        <FaCss3Alt className={styles.icon} title="CSS3" />
        <FaJs className={styles.icon} title="JavaScript" />
        <FaReact className={styles.icon} title="React" />
        <FaNodeJs className={styles.icon} title="Node.js" />
        <FaPhp className={styles.icon} title="PHP" />
        <SiMysql className={styles.icon} title="MySQL" />
        <SiMongodb className={styles.icon} title="MongoDB" />
        <FaGitAlt className={styles.icon} title="Git" />
        <FaGithub className={styles.icon} title="GitHub" />
      </div>
    </section>
  );
}
